import React, { Component } from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Button, Modal, Segment } from "semantic-ui-react";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import UiMeet3dLinkPairSegment from "~/modules/UiMeet3d/components/UiMeet3dLinkPairSegment";
import ContentLoader from "~/components/element/ContentLoader";
import UiMeet3dLink from "~/models/UiMeet3d/UiMeet3dLink";

@observer
class UiMeet3dLinkPairs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmationModalVisible: false,
      selectedUiMeet3dLinkPairIndex: null,
      selectedRoomId: null,
    };
  }

  @computed
  get rooms() {
    const { uiMeet3dLinks } = this.props;

    if (uiMeet3dLinks.length === 0) {
      return [];
    }

    const rooms = [];

    uiMeet3dLinks.forEach(uiMeet3dLink => {
      rooms.indexOf(uiMeet3dLink.roomId) === -1 && rooms.push(uiMeet3dLink.roomId);
    });

    return rooms;
  }

  showConfirmationModal = (selectedUiMeet3dLinkPairIndex, selectedRoomId) =>
    this.setState({ selectedUiMeet3dLinkPairIndex, selectedRoomId, confirmationModalVisible: true });

  hideConfirmationModal = () =>
    this.setState({ selectedUiMeet3dLinkPairIndex: null, selectedRoomId: null, confirmationModalVisible: false });

  render() {
    const {
      t,
      uiMeet3dLinks,
      isLoading,
      deleteUiMeet3dLinkPairCallback,
      defaultPhotoPathWeb,
      defaultLogoPathWeb,
      showUiMeet3dLinkFormModalCallback,
    } = this.props;
    const { confirmationModalVisible, selectedUiMeet3dLinkPairIndex, selectedRoomId } = this.state;
    if (isLoading) {
      return <ContentLoader />;
    }

    if (this.rooms.length === 0) {
      return (
        <Segment style={{ marginTop: "1rem" }}>
          <p>{t("clientPanelMisc:noUiMeet3dGeneratedLinks")}</p>
        </Segment>
      );
    }

    return (
      <>
        {this.rooms.map((currentRoomId, index) => (
          <UiMeet3dLinkPairSegment
            key={currentRoomId}
            order={index}
            roomId={currentRoomId}
            uiMeet3dLinks={uiMeet3dLinks.filter(uiMeet3dLink => uiMeet3dLink.roomId === currentRoomId)}
            showConfirmationModalCallback={(uiMeet3dLinkPairIndex, roomId) =>
              this.showConfirmationModal(uiMeet3dLinkPairIndex, roomId)
            }
            showUiMeet3dLinkFormModalCallback={(
              uiMeet3dLinkPairIndex,
              roomId,
              photoPathWeb,
              logoPathWeb,
              uiMeet3dLink,
            ) =>
              showUiMeet3dLinkFormModalCallback(uiMeet3dLinkPairIndex, roomId, photoPathWeb, logoPathWeb, uiMeet3dLink)
            }
            defaultPhotoPathWeb={defaultPhotoPathWeb}
            defaultLogoPathWeb={defaultLogoPathWeb}
          />
        ))}
        <Modal open={confirmationModalVisible} onClose={() => this.hideConfirmationModal()}>
          <Modal.Header>
            {t("clientPanelMisc:deleteUiMeet3dGeneratedLinkConfirmation", { index: selectedUiMeet3dLinkPairIndex })}
          </Modal.Header>
          <Modal.Actions>
            <Button secondary onClick={() => this.hideConfirmationModal()}>
              {t("cancel")}
            </Button>
            <Button
              primary
              onClick={() => {
                deleteUiMeet3dLinkPairCallback(selectedRoomId);
                this.hideConfirmationModal();
              }}
            >
              {t("ok")}
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}

UiMeet3dLinkPairs.propTypes = {
  t: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  uiMeet3dLinks: PropTypes.arrayOf(PropTypes.instanceOf(UiMeet3dLink)),
  deleteUiMeet3dLinkPairCallback: PropTypes.func.isRequired,
  showUiMeet3dLinkFormModalCallback: PropTypes.func.isRequired,
  defaultPhotoPathWeb: PropTypes.string,
  defaultLogoPathWeb: PropTypes.string,
};

export default withTranslation()(ErrorWrapper(UiMeet3dLinkPairs));
